import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { UtilityModule } from '../utility/utility.module';
import { GenericEntitySearchComponent } from './generic-entity-search/generic-entity-search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { DocumentViewerModule } from '../document-viewer/document-viewer.module';
import { GenericLogoutWarningDialogComponent } from './generic-logout-warning-dialog/generic-logout-warning-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    UtilityModule,
    ReactiveFormsModule,
    NgxMaskModule,
    DocumentViewerModule,
  ],
  exports: [],
  declarations: [GenericDialogComponent, GenericEntitySearchComponent, GenericLogoutWarningDialogComponent],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { width: '80vw', data: null, hasBackdrop: true, disableClose: true, restoreFocus: true },
    },
  ],
  entryComponents: [GenericDialogComponent, GenericEntitySearchComponent,GenericLogoutWarningDialogComponent],
})
export class DialogModule {}
